import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uplodateLoading } from '../../../redux/features/common/commonSlice';
import urls from '../../constants/apiurl';
import ApiCaller from '../../constants/ApiCaller';
import { showDangerToast } from '../../constants/toaster';
import { Modal, Box, Pagination, Button } from '@mui/material';
import { NavBarTop } from '../../structure/NavBarTop';
import { useLocation, useNavigate } from 'react-router-dom';
import NavBar from '../../structure/NavBar';
import { InputGroup, Form } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import ReplyIcon from '@mui/icons-material/Reply'
import dayjs from 'dayjs';
import { formatIndianNumber } from '../../lib/formatIndianNumber';

const CashWalletTransactionHistory = ({ isStandalonePage = false, email: propEmail, onClose }) => {
  const dispatch = useDispatch();
  const userData = useSelector(state => state?.userData);
  const location = useLocation();
    const router = useNavigate()
  const navigate = useNavigate();
  const [datalist, setDatalist] = useState([]);
  const [page, setPage] = useState(1);
  const [pagerecord, setPagerecord] = useState({
    totalItems: 0,
    pageNumber: 1,
    pageSize: 10,
    totalPages: 1
  });
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [email, setEmail] = useState(propEmail || '');
  const [searchText, setSearchText] = useState('');
  const [statusDropdownText, setStatusDropdownText] = useState('Select Status');
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    if (isStandalonePage) {
      const params = new URLSearchParams(location.search);
      setEmail(params.get('email') || '');
    } else {
      setEmail(propEmail || '');
    }
  }, [isStandalonePage, location.search, propEmail]);

  useEffect(() => {
    if (email)  
    getTransactionHistory();
    // eslint-disable-next-line
  }, [email, page, limit]);

  const getTransactionHistory = async (customFilters = {}) => {
    try {
      dispatch(uplodateLoading(true));
      const fromDate = customFilters.startDate !== undefined ? customFilters.startDate : startDate;
      const toDate = customFilters.endDate !== undefined ? customFilters.endDate : endDate;
      const postJson = {
        sort: 'createdAt',
        order: false,
        page: page - 1,
        limit: limit,
        txnId: customFilters.searchText !== undefined ? customFilters.searchText : searchText,
        toUserId: '',
        transactionType: customFilters.statusDropdownText !== undefined && customFilters.statusDropdownText !== 'Select Status' ? customFilters.statusDropdownText : (statusDropdownText !== 'Select Status' ? statusDropdownText : 'ALL'),
        startDate: fromDate && fromDate.format ? fromDate.format('YYYY-MM-DD') : undefined,
        endDate: toDate && toDate.format ? toDate.format('YYYY-MM-DD') : undefined
      };
      const url = `${urls.viewUserCashTransactions}?email=${encodeURIComponent(email)}`;
      const res = await ApiCaller.post(postJson, url, userData?.access_token);
      const response = await res.response.json();
      const apiData = response.data?.data || response.data;
      if (
        response.status === 'OK' ||
        response.status === 200 ||
        response.status === '200' ||
        response.code === '200'
      ) {
        dispatch(uplodateLoading(false));
        setDatalist(Array.isArray(apiData.items) ? apiData.items : []);
        setPagerecord({
          totalItems: apiData.totalItems || (apiData.items?.length || 0),
          totalPages: apiData.totalPages || 1,
          pageNumber: typeof apiData.pageNumber === 'number' ? apiData.pageNumber + 1 : page,
          pageSize: apiData.pageSize || 10
        });
      } else {
        dispatch(uplodateLoading(false));
        showDangerToast(response.message || 'Something went wrong');
      }
    } catch (error) {
      dispatch(uplodateLoading(false));
      showDangerToast(error.message || 'Server Error');
    }
  };

  const handleChange = (event, value) => {
    setPage(value);
  };

  // ADDED: Page Per Count Feature
  const handleLimitChange = (e) => {
    setLimit(Number(e.target.value));
    setPage(1);
  };

  const isReceived = (item) => {
    const type = String(item.transactionType || item.type || '').toUpperCase();
    return /CREDIT|RECEIVED|IN|ADD|RECEIVE|CR/.test(type);
  };

  const getAmount = (item) => {
    if (item.amount !== undefined && item.amount !== null) return formatIndianNumber(item.amount);
    if (item.beads !== undefined && item.beads !== null) return formatIndianNumber(item.beads);
    return formatIndianNumber(0);
  };

  const handleFilterClick = () => {
    setPage(1);
    setTimeout(() => {
      getTransactionHistory({
        searchText,
        statusDropdownText,
        startDate,
        endDate
      });
    }, 0);
  };

  const handleResetFilter = () => {
    setStartDate(null);
    setEndDate(null);
    setSearchText('');
    setStatusDropdownText('Select Status');
    setPage(1);
    setTimeout(() => {
      getTransactionHistory({
        searchText: '',
        statusDropdownText: 'ALL',
        startDate: null,
        endDate: null
      });
    }, 0);
  };

  if (!email) {
    return (
      <div className="main-content">
        <NavBarTop />
        <div className="container-fluid mt--7">
          <h3>No email provided in URL.</h3>
        </div>
      </div>
    );
  }

  return (
    isStandalonePage ? (
      <>
        <NavBar />
        <div className='main-content'>
          <NavBarTop />
          <div className='header'>
            <div className='logo'>
              <div className='header bg-gradient-primary pb-8 pt-5 pt-md-8'></div>
            </div>
          </div>
          <div className='container-fluid mt--7'>
            <div className='row'>
              <div className='col text-left'>
               
                 <div className='col-md-12 text-left'>
                              <a
                                onClick={() => {
                                  const returnTo = location.state?.returnTo;
                                  if (returnTo && returnTo.page != null) {
                                    navigate('/cash-wallet-manager', { state: returnTo });
                                  } else {
                                    navigate('/cash-wallet-manager');
                                  }
                                }}
                                className='btn btn-sm btn-primary text-white'
                              >
                                <ReplyIcon />
                                Back
                              </a>
                            </div>
                <div className='card shadow mb-4'>
                  <div className='card-header border-0 d-flex justify-content-between align-items-center'>
                    <h3 className='mb-0'>Cash Transaction History</h3>
                  </div>
                  <div className='card-header border-0'>
                    <div className='row align-items-center text-left'>
                      <div className='col-md-6 mb-3' style={{ marginLeft: '40px' }}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer components={['DatePicker', 'DatePicker']}>
                            <DatePicker
                              className='custom-date'
                              label='From Date'
                              value={startDate}
                              onChange={newValue => setStartDate(newValue)}
                              maxDate={endDate || undefined}
                            />
                            <DatePicker
                              label='To Date'
                              value={endDate}
                              onChange={newValue => setEndDate(newValue)}
                              minDate={startDate || undefined}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>
                      <div className='col-md-3 mb-2'>
                        <Button
                          variant='contained'
                          className='custom-filter-btn'
                          onClick={handleFilterClick}
                        >
                          Filter
                        </Button>
                        <Button
                          variant='contained'
                          className='ml-2 custom-filter-btn'
                          onClick={handleResetFilter}
                        >
                          Reset
                        </Button>
                      </div>
                    </div>
                  </div>
                  <div className='card-body'>
                    <div className='table-responsive'>
                      <table className='table align-items-center table-flush'>
                        <thead className='thead-light'>
                          <tr>
                            <th>#</th>
                            <th>Type</th>
                            <th style={{ backgroundColor: 'rgba(34, 197, 94, 0.15)' }}>Received</th>
                            <th style={{ backgroundColor: 'rgba(239, 68, 68, 0.15)' }}>Paid</th>
                            <th>Date</th>
                            <th>Description</th>
                          </tr>
                        </thead>
                        <tbody>
                          {Array.isArray(datalist) && datalist.length > 0 ? datalist.map((item, idx) => {
                            const received = isReceived(item);
                            const amount = getAmount(item);
                            const rowStyle = received
                              ? { backgroundColor: 'rgba(34, 197, 94, 0.08)' }
                              : { backgroundColor: 'rgba(239, 68, 68, 0.08)' };
                            return (
                              <tr key={idx} style={rowStyle}>
                                <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                                <td>{item.transactionType || item.type || '-'}</td>
                                <td style={{ color: received ? '#15803d' : undefined, fontWeight: received ? 600 : undefined }}>
                                  {received ? amount : '-'}
                                </td>
                                <td style={{ color: !received ? '#b91c1c' : undefined, fontWeight: !received ? 600 : undefined }}>
                                  {!received ? amount : '-'}
                                </td>
                                <td>{item.createdAt || item.createdDate || item.date}</td>
                                <td>{item.txnNote || item.description || '-'}</td>
                              </tr>
                            );
                          }) : (
                            <tr><td colSpan={6} className='text-center'>No Data Found</td></tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className='card-footer py-4'>
                    <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap' gap={2}>
                      <span>Total record: {pagerecord?.totalItems}</span>
                      <Box display='flex' alignItems='center' gap={2} flexWrap='wrap'>
                        {/* ADDED: Page Per Count Feature */}
                        <Form.Select
                          value={limit}
                          onChange={handleLimitChange}
                          style={{ width: 'auto', minWidth: '70px' }}
                          size='sm'
                        >
                          <option value={10}>10</option>
                          <option value={25}>25</option>
                          <option value={50}>50</option>
                          <option value={100}>100</option>
                        </Form.Select>

                        <Pagination
                          className='custom-pagination-class'
                          count={pagerecord?.totalPages}
                          page={page}
                          onChange={handleChange}
                          color='secondary'
                        />
                      </Box>
                    </Box>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    ) : (
      <Modal open={true} onClose={onClose}>
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', bgcolor: 'background.paper', p: 4, borderRadius: 2, boxShadow: 24, minWidth: 600 }}>
          <h4>Transaction History</h4>
          <div className='table-responsive'>
            <table className='table align-items-center table-flush'>
              <thead className='thead-light'>
                <tr>
                  <th>#</th>
                  <th>Type</th>
                  <th style={{ backgroundColor: 'rgba(34, 197, 94, 0.15)' }}>Received</th>
                  <th style={{ backgroundColor: 'rgba(239, 68, 68, 0.15)' }}>Paid</th>
                  <th>Date</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                {Array.isArray(datalist) && datalist.length > 0 ? datalist.map((item, idx) => {
                  const received = isReceived(item);
                  const amount = getAmount(item);
                  const rowStyle = received
                    ? { backgroundColor: 'rgba(34, 197, 94, 0.08)' }
                    : { backgroundColor: 'rgba(239, 68, 68, 0.08)' };
                  return (
                    <tr key={idx} style={rowStyle}>
                      <td>{(pagerecord.pageNumber - 1) * pagerecord.pageSize + idx + 1}</td>
                      <td>{item.transactionType || item.type || '-'}</td>
                      <td style={{ color: received ? '#15803d' : undefined, fontWeight: received ? 600 : undefined }}>
                        {received ? amount : '-'}
                      </td>
                      <td style={{ color: !received ? '#b91c1c' : undefined, fontWeight: !received ? 600 : undefined }}>
                        {!received ? amount : '-'}
                      </td>
                      <td>{item.createdAt || item.createdDate || item.date}</td>
                      <td>{item.txnNote || item.description || '-'}</td>
                    </tr>
                  );
                }) : (
                  <tr><td colSpan={6} className='text-center'>No Data Found</td></tr>
                )}
              </tbody>
            </table>
          </div>
          <Box display='flex' justifyContent='space-between' alignItems='center' flexWrap='wrap' gap={2} mt={3}>
            <span>Total record: {pagerecord?.totalItems}</span>
            <Box display='flex' alignItems='center' gap={2} flexWrap='wrap'>
              {/* ADDED: Page Per Count Feature */}
              <Form.Select
                value={limit}
                onChange={handleLimitChange}
                style={{ width: 'auto', minWidth: '70px' }}
                size='sm'
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </Form.Select>

              <Pagination
                className='custom-pagination-class'
                count={pagerecord?.totalPages}
                page={page}
                onChange={handleChange}
                color='secondary'
              />
            </Box>
          </Box>
          <Box mt={2} display='flex' justifyContent='flex-end'>
            <Button variant='outlined' color='secondary' onClick={onClose}>Close</Button>
          </Box>
        </Box>
      </Modal>
    )
  );
};

export default CashWalletTransactionHistory;
